import React from 'react'

import { useParams } from 'react-router'
import { Button } from 'src/components/__legacy__/button/button'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { submitReInvite } from './request'
import { trialIdParamName } from '../../trial-detail'

type Props = {
  memberUid: string
}

export const ReInvitationButton: React.FC<Props> = props => {
  const { memberUid } = props

  const { trialUid = '' } = useParams<{ [trialIdParamName]: string }>()

  const toast = useMirohaToast()

  const onSubmit = async () => {
    await submitReInvite({ memberUid, trialUid })

    toast({ status: 'success', title: '招待メールを再送信しました' })
  }

  return (
    <Button
      text="再送信"
      size="S"
      buttonType="normal"
      iconName="email"
      onClick={onSubmit}
    />
  )
}
